import { render, staticRenderFns } from "./ListProductsTagChantier.vue?vue&type=template&id=583f41d4&"
import script from "./ListProductsTagChantier.vue?vue&type=script&lang=js&"
export * from "./ListProductsTagChantier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListProductsTagChantier.vue"
export default component.exports